import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface SurveyTimeProps {
  color?: string;
  style?: React.CSSProperties;
}

export const SurveyTimeIcon = ({ color = RoutalPalette.white, style = {}, ...props }: SurveyTimeProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 14 15" style={{ width: `14px`, height: `15px`, ...style }}>
      <path
        d="M7 13.9038C10.3137 13.9038 13 11.2175 13 7.90381C13 4.5901 10.3137 1.90381 7 1.90381C3.68629 1.90381 1 4.5901 1 7.90381C1 11.2175 3.68629 13.9038 7 13.9038Z"
        fill="#CBD2D7"
        stroke="#CBD2D7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 4.30371V7.90371L9.4 9.10371"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
